/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnLeftDown: {
  name: 'arrow-turn-left-down';
  data: string;
} = {
  name: 'arrow-turn-left-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 1a.5.5 0 0 1-.5.5H8a.5.5 0 0 0-.5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L6.5 13.793V2A1.5 1.5 0 0 1 8 .5h5a.5.5 0 0 1 .5.5Z" fill="currentColor"/></svg>`,
};
